var styles = {"popup":"navkit__Tooltip__popup","tooltipContent":"navkit__Tooltip__tooltipContent","isEllipsis":"navkit__Tooltip__isEllipsis","isBreakAll":"navkit__Tooltip__isBreakAll"};

export { styles as default };
